import { Pipe, PipeTransform, SecurityContext } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({
  name: 'replace'
})
export class ReplacePipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  transform(
    value: string,
    replacement: string,
    start: string = '',
    end: string = ''
  ) {
    let newValue = value;

    if (newValue) {
      replacement = this.escapeBraces(replacement);
      const regEx = new RegExp(replacement, 'ig');

      newValue = newValue.replace(regEx, (matched) => {
        return (
          start + this.sanitizer.sanitize(SecurityContext.HTML, matched) + end
        );
      });
    }

    return this.sanitizer.bypassSecurityTrustHtml(newValue);
  }

  // to escape the braces that appears with the origin and destination name
  escapeBraces(stringVal: string): string {
    if (stringVal) {
      return stringVal.replace(/[()]/g, '\\$&');
    }
    return '';
  }
}
